<template>
  <div >
    <span class="redirect-title" style="font-size: 16px;margin-bottom: 15px">Source NAT</span>
    <el-table :data="redirectList" border strip style="margin-top: 15px">
      <el-table-column :label="`${$t('lang.ConfigSetting.Rule')}`">
        <template slot-scope="scope">
          <el-checkbox v-model="scope.row.options.enabled">{{$t('lang.ConfigSetting.Enable')}}</el-checkbox>
        </template>
      </el-table-column>
      <el-table-column :label="`${$t('lang.ConfigSetting.name')}`">
        <template slot-scope="scope">
          <span>{{scope.row.options.name}}</span>
        </template>
      </el-table-column>
      <el-table-column :label="`${$t('lang.ConfigSetting.protocols')}`">
        <template slot-scope="scope">
          <span>{{scope.row.options.proto}}</span>
        </template>
      </el-table-column>
      <el-table-column :label="`${$t('lang.ConfigSetting.SRC')}`">
        <template slot-scope="scope">
          <span>{{SRCOptions[scope.row.options.src]}}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column :label="`${$t('lang.ConfigSetting.SRCIp')}`" min-width="110px">
        <template slot-scope="scope">
          <span>{{scope.row.options.src_ip}}</span>
        </template>
      </el-table-column> -->
      <el-table-column :label="`${$t('lang.ConfigSetting.dest')}`">
        <template slot-scope="scope">
          <span>{{SRCOptions[scope.row.options.dest]}}</span>
        </template>
      </el-table-column>
      <el-table-column :label="`${$t('lang.ConfigSetting.dest_ip')}`" min-width="110px">
        <template slot-scope="scope">
          <span>{{scope.row.options.dest_ip}}</span>
        </template>
      </el-table-column>
      <el-table-column :label="`${$t('lang.ConfigSetting.SNAT')}`" min-width="110px">
        <template slot-scope="scope">
          <span>{{scope.row.options.src_dip}}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column :label="`${$t('lang.ConfigSetting.Extraarguments')}`"></el-table-column> -->
      <el-table-column :label="`${$t('lang.ConfigSetting.operating')}`" min-width="150px"> 
        <template slot-scope="scope">
          <el-button type="primary" size="small" @click="editRedirect(scope.row)">{{$t('lang.Button.edit')}}</el-button>
          <el-button type="danger" size="small" @click="deleteRedirect(scope.row, scope.$index)">{{$t('lang.Button.delete')}}</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 添加SNAT -->
    <add-redirect ref="addRedirect" @addRedirect='addRedirect' :IpList="IpList"></add-redirect>
    <!-- 编辑端口 -->
    <edit-dialog ref="editDialog" :IpList="IpList" :deviceDid="deviceDid" :deviceSn="deviceSn" @updateData="updateData"></edit-dialog>
  </div>
</template>
<script>
import SelectInput from '../../SelectInput/index'
import addRedirect from './addRedirect'
import editDialog from './editDialog'
export default {
  props: ['redirectList',"IpList", 'redirectLength', 'deleteOptions',"deviceDid", "deviceSn"],
  components: {
    SelectInput,
    addRedirect,
    editDialog
  },
  data() {
    return {
       SRCOptions: {
         'wan' : 'wan',
         'lan': 'lan',
         '未指定': 'DROP'
       },
        protoOptions: {
          'TCP': 'TCP',
          'UDP': 'UDP',
          'TCP+UDP': 'TCP+UDP',
          'ICMP': 'ICMP',
          'all': 'All protocals'
        },
      isDisplay: [],
      IPOptions:[],
      loading: true,
      rLength: 0,
    }
  },
  watch: {
    'redirectList': {
      immediate: true,
      handler: function(newVal){
        if(this.redirectList.length > 0){
          this.redirectList.forEach((item) => {
            if(item.options.enabled === '1' || item.options.enabled) {
              item.options.enabled = true
            }else{
              item.options.enabled = false
            }
            this.isDisplay.push('inline')
          })
        }
      }
    },
    'IpList': {
      immediate: true,
      deep: true,
      handler: function(newVal){          
          this.IPOptions = newVal
        }
    },
    redirectLength: {
      immediate: true,
      handler: function() {
        if(this.redirectLength) {
          this.rLength = this.redirectLength
        }
      }
    }
  },
  methods: {
    // 获取下拉框返回的值并更新到通信规则相应的数据中。
    IpSelectInput(props,index){
      this.redirectList[index[0]].options[`${index[1]}`] = props
    },
    // 添加SNAT
    addRedirect(value){
      let redirectObj = value
      redirectObj.index = this.rLength
      this.rLength = this.rLength + 1
      this.redirectList.push(redirectObj)
    },
    deleteRedirect(row, index) {
      if(row.action == undefined){// 不是后来添加的数据,若是原来的数据则保存到待删除数组中
         this.deleteOptions.push({
           index: row.index,
           options: row.options,
           sname: row.sname,
           action: 2
         })
         // 在列表中删除
         this.redirectList.splice(index, 1)
      }else{// 不然直接在列表中删除即可
        this.redirectList.splice(index, 1)
      }
    },
    editRedirect(row) {
      this.$refs.editDialog.show(row, row.index)
    },
    // 编辑后更新数据
    updateData() {
      this.$emit('updateData')
    }
  }
}
</script>
<style scoped>
.table{
  width: 100%;
}
.table-tr{
  width: 10%;
  color: #333333;
  text-align: center;
  display: inline-block;
  font-weight: bold;
}
.table-body{
  width: 100%;
}
.table-header{
  width: 100%;
  margin-top: 20px;
}
.table-td{
  width: 10%;
  text-align: center;
  display: inline-block;
  margin: 10px 0px;
}
.nodata_tip{
  width: 100px;
  height: 50px;
  text-align: center;
  color: grey;
  margin-top: 20px;
  margin-bottom: 20px;
  margin: 20px auto 20px auto;
  font-size: 15px;
}
</style>